import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import AssetForm from '../components/AssetForm';
import { requestAssetOwnerTypes, requestAssetDetails, updateAssetDetails, requestAssetTypesByCategoryId, requestAssetCategories, requestAssetStatuses } from '../../../store/asset-manager';
import { requestClinicLocationsTypeahead } from '../../../store/location-manager/LocationManagerActions';
import { requestClientsTypeahead } from '../../../store/client-manager/ClientManagerActions';
import { hostTitle } from '../../../config/ui';


class AssetEdit extends React.Component {
  componentWillMount() {
    this.props.getAsset(this.props.params.id, {
      tenantId: this.props.tenantId,
    });
  }

  onSubmit = (values) => {
    this.props
      .updateAssetDetails(values, {
        tenantId: this.props.tenantId,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('Asset has been saved.');
          hashHistory.push('/asset-manager/');
        }
      });
  };

  onCancel = () => {
    hashHistory.push('/asset-manager/');
  };

  searchLocations = (search) => {
    return this.props
      .locationsTypeahead({
        tenantId: this.props.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ clinicLocationID: item.code, siteName: item.name }),
          );
        }
        return options;
      });
  };
  
  searchClients = (search) => {
    return this.props
      .clientsTypeahead({
        tenantId: this.props.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ employerCodeNumber: item.code, employerCodeDescription: item.name }),
          );
        }
        return options;
      });
  };

  searchAssetOwnerTypes = () => {
    return this.props
      .getAssetOwnerTypes({
        tenantId: this.props.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchAssetTypesByCategory = (categoryId) => {
    return this.props
      .getAssetTypes({
        tenantId: this.props.tenantId,
        categoryId: categoryId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchAssetCategories = () => {
    return this.props
      .getAssetCategories({
        tenantId: this.props.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchAssetStatuses = () => {
    return this.props
      .getAssetStatuses({
        tenantId: this.props.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  render() {
    const {
      data: { asset,
        isLoading,
      },
    } = this.props;

    return (
      <div id="content">
        {asset.id && <Helmet title={`${asset.id} – ${hostTitle()}`} />}
        <BigBreadcrumbs
          items={[
            'Administration',
            { title: 'Asset Manager', route: '/asset-manager' },
            'Asset',
          ]}
          icon="fa fa-fw fa-database"
          className=""
        />

        <WidgetGrid>
          <JarvisWidget
            color="white"
            fullscreenbutton={true}
            colorbutton={false}
            closeButton={true}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                {' '}
                <i className="fa fa-table" />{' '}
              </span>
              <h2>{
                asset.id && `Edit Asset `}
                {asset.id && <i>({asset.id})</i>}
                {!asset.id && `Add Asset `}
              </h2>
            </header>
            <div>
              <div className="widget-body">
                {asset.id && (
                  <AssetForm
                    isLoading={isLoading}
                    searchAssetTypesByCategory={this.searchAssetTypesByCategory}
                    searchAssetOwnerTypes={this.searchAssetOwnerTypes}
                    searchClients={this.searchClients}
                    searchLocations={this.searchLocations}
                    searchAssetCategories={this.searchAssetCategories}
                    searchAssetStatuses={this.searchAssetStatuses}
                    mode={this.props.params.mode}
                    onSubmit={this.onSubmit}
                    onCancel={this.onCancel}
                  />
                )}
              </div>
            </div>
          </JarvisWidget>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.assetmanager,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getAsset: (assetId, params) => dispatch(requestAssetDetails(assetId, params)),
    getAssetOwnerTypes: (params) => dispatch(requestAssetOwnerTypes(params)),
    clientsTypeahead: (params) => dispatch(requestClientsTypeahead(params)),
    getAssetTypes: (params) => dispatch(requestAssetTypesByCategoryId(params)),
    locationsTypeahead: (params) => dispatch(requestClinicLocationsTypeahead(params)),
    getAssetCategories: (params) => dispatch(requestAssetCategories(params)),
    getAssetStatuses: (params) => dispatch(requestAssetStatuses(params)),
    updateAssetDetails: (asset, params) => dispatch(updateAssetDetails(asset, params)),
  }),
)(AssetEdit);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/AssetEdit.js